const columns = () => [
  {
    name: 'Nombre',
    selector: 'full_name',
    sortable: true,
    grow: 2
  },
  {
    name: 'RUT',
    selector: 'national_identification',
    sortable: true,
    grow: 1
  },
  {
    name: 'Lugar de Prestación de Servicios',
    selector: 'branch_offices_name',
    sortable: true,
    grow: 2
  }
];

export default columns;
